import React, {createContext, useEffect, useState} from 'react';
import Loader from "../general_components/Loader";
import SuccessMessage from "../general_components/SuccessMessage";
import ConstantsService from "../services/ConstantsService";

export const ConstantsContext = createContext();

export default function ConstantsContextProvider({children}) {

    const [open, setOpen] = useState(false);
    const [confirm, setConfirm] = useState(false);

    const [constants, setConstants] = useState([]);

    useEffect(() => {
        getConstants();
    }, []);

    const getConstants = () => {
        ConstantsService.getConstants().then(response => {
            if(response.data.success){
                setConstants(response.data.data);
            }
        }).catch(() => {});
    }

    return (
        <ConstantsContext.Provider value={{
            constants, setConstants
        }}>
            {children}
            <Loader open={open} close={setOpen}/>
            <SuccessMessage open={confirm} close={setConfirm}/>
        </ConstantsContext.Provider>
    )
}